import { useState } from "react";
import type { PomodoroSettings } from "../../types/timer-settings";
import { DurationSlider, ToggleSwitch, SoundConfigRow } from "./TimerSettingsAtoms";

interface PomodoroSettingsSectionProps {
  readonly settings: PomodoroSettings;
  readonly onUpdate: (patch: Partial<PomodoroSettings>) => void;
}

export function PomodoroSettingsSection({ settings, onUpdate }: PomodoroSettingsSectionProps) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="border border-border rounded-lg overflow-hidden">
      <button
        type="button"
        onClick={() => setExpanded((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-2.5 bg-surface-alt hover:bg-surface-alt/80 text-sm font-semibold text-ink"
      >
        <span>Pomodoro</span>
        <span className="text-ink-muted text-xs">{expanded ? "▲" : "▼"}</span>
      </button>

      {expanded && (
        <div className="px-4 py-3 flex flex-col gap-4">
          <DurationSlider
            label="Travail"
            value={settings.workDuration}
            min={1}
            max={120}
            unit="min"
            onChange={(v) => onUpdate({ workDuration: v })}
          />
          <DurationSlider
            label="Pause courte"
            value={settings.shortBreakDuration}
            min={1}
            max={30}
            unit="min"
            onChange={(v) => onUpdate({ shortBreakDuration: v })}
          />
          <DurationSlider
            label="Pause longue"
            value={settings.longBreakDuration}
            min={1}
            max={60}
            unit="min"
            onChange={(v) => onUpdate({ longBreakDuration: v })}
          />
          <DurationSlider
            label="Sessions avant longue pause"
            value={settings.sessionsBeforeLongBreak}
            min={1}
            max={12}
            unit=""
            onChange={(v) => onUpdate({ sessionsBeforeLongBreak: v })}
          />
          <ToggleSwitch
            label="Demarrage automatique"
            checked={settings.autoStartNext}
            onChange={(v) => onUpdate({ autoStartNext: v })}
          />
          <ToggleSwitch
            label="Demarrer au skip"
            checked={settings.autoStartOnSkip}
            onChange={(v) => onUpdate({ autoStartOnSkip: v })}
          />
          <SoundConfigRow
            label="Son fin de travail"
            config={settings.workEndSound}
            onChange={(v) => onUpdate({ workEndSound: v })}
          />
          <SoundConfigRow
            label="Son fin de pause"
            config={settings.breakEndSound}
            onChange={(v) => onUpdate({ breakEndSound: v })}
          />
        </div>
      )}
    </div>
  );
}
